<shared-button-group [buttons]="buttons" (buttonClick)="buttonClicked($event)"></shared-button-group>
